import axios from "../../axios";

export const createAdmin = async (adminData) => {
    return await axios.post(`/admins`, adminData);
}

export const deleteAdmin = async (adminId) => {
    return await axios.delete(`/admins/${adminId}`);
}